import { FC, useEffect } from "react";
import { css } from "@emotion/react";
import f from "@/module/Utils/emotion";
import v from "@/module/Utils/variable";
import Util from "@/module/Utils/Util";
import { globFunc } from "@/store/index";

// Components
import Picture from "@/components/Atoms/Picture";
import SBAs from "@/images/common/icon_sbas.png";
import SHISEIDO from "@/images/common/icon_shiseido_sp.svg";
import * as React from "react";

interface OpeningProps {
  onAnimationEnd?: () => void;
}
const Opening: FC<OpeningProps> = (props) => {
  // Styles
  const openingLogoDecorations = css({
    display: "flex",
    alignItems: "center",
    position: "absolute",
    [f.sp()]: {
      top: `calc(50% + ${f.vw(227, v.spWidth)})`,
      left: f.vw(159, v.spWidth),
    },
    [f.pc()]: {
      top: `calc(50% + ${f.vw(209)})`,
      left: f.vw(496),
    },
  });

  const openingLogoSBasStyle = css({
    [f.sp()]: {
      width: f.vw(188, v.spWidth),
    },
    [f.pc()]: {
      width: f.vw(166),
    },
  });

  const openingLogoLine = css({
    width: "1px",
    backgroundColor: "#fff",
    [f.sp()]: {
      height: f.vw(67.66, v.spWidth),
      marginLeft: f.vw(27.5, v.spWidth),
      marginRight: f.vw(18.5, v.spWidth),
    },
    [f.pc()]: {
      height: f.vw(58.78),
      marginLeft: f.vw(21),
      marginRight: f.vw(18.4),
    },
  });

  const openingLogoSHISEIDOStyle = css({
    [f.sp()]: {
      width: f.vw(206, v.spWidth),
    },
    [f.pc()]: {
      width: f.vw(164),
    },
  });

  const openingLogoStyle = css({
    position: "absolute",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: -2,
    [f.sp()]: {
      width: f.vw(248, v.spWidth),
      top: `calc(50% - ${f.vw(28, v.spWidth)})`,
    },
    [f.pc()]: {
      width: f.vw(268),
      top: `calc(50% - ${f.vw(24)})`,
    },
  });

  // logics
  const animationEnd = async () => {
    await Util.sleep(1500);
    globFunc.getState().sketch.drawCloseEye(props.onAnimationEnd);
  };

  useEffect(() => {
    globFunc
      .getState()
      .setElement(<div css={openingLogoStyle}>{props.children}</div>);
    globFunc
      .getState()
      .sketch.drawOpenEye(
        1,
        { pc: -24 / v.pcWidth, sp: -29 / v.spWidth },
        { pc: 700, sp: 659 },
        animationEnd
      );
  }, []);

  return (
    <div css={openingLogoDecorations}>
      <div css={openingLogoSBasStyle}>
        <Picture path={SBAs} alt={"SBAS SUSTAINABLE BEAUTY ACTIONS"} />
      </div>
      <div css={openingLogoLine} />
      <div css={openingLogoSHISEIDOStyle}>
        <Picture path={SHISEIDO} alt={"SHISEIDO GINZA TOKYO"} />
      </div>
    </div>
  );
};

export default Opening;
